import { urlFormat } from "../../seo/seo-helper";
import { Property, PropertyDocument } from "../../types/property-types";
import { getProperties } from "./property-fetcher";

interface PropertyPathConfig {
  id: string;
  name: string;
  city?: string;
  state?: string;
  country?: string;
}

export const getPropertyPaths = async (): Promise<string[]> => {
  // Fetch all of the properties from APIM and get the path for each property
  const paths = await getProperties()
    .then((response) => {
      if (!response?.Documents) {
        return [];
      }
      return response?.Documents.map((property: PropertyDocument) => {
        return getPropertyDocumentPath(property);
      });
    })
    .catch((error) => {
      console.error("Error fetching properties:", error);
      return [];
    });

  return paths;
};

export const getPropertyPath = (property: Property): string | undefined => {
  if (!property.location) {
    return undefined;
  }

  if (property.location.urlSlug !== "") {
    return `/${property.location.urlSlug}/p_${property.id}`;
  }

  const config: PropertyPathConfig = {
    id: property.id,
    name: property.name,
    city: property.location?.city,
    state: property.location?.state,
    country: property.location?.countryCode,
  };

  return getPropertyPathFromConfig(config);
};

export const getPropertyDocumentPath = (property: PropertyDocument): string => {
  const config: PropertyPathConfig = {
    id: property.id,
    name: property.name,
    city: property.city,
    state: property.state,
    country: property.countryCode,
  };

  return getPropertyPathFromConfig(config);
};

const getPropertyPathFromConfig = (config: PropertyPathConfig): string => {
  let path = `/${urlFormat(config.name, false)}`;

  if (config.city) {
    path += `-${urlFormat(config.city, false)}`;
  }

  if (config.state) {
    path += `-${urlFormat(config.state, false)}`;
  }

  if (config.country) {
    path += `-${urlFormat(config.country, false)}`;
  }

  return `${path}/p_${config.id}`;
};
